import { cookie } from '@ifeng/ui_base';

const allRegionList = {
    cn0311: '河北',
    cn0531: '山东',
    cn024: '辽宁',
    cn0451: '黑龙江',
    cn0431: '吉林',
    cn0943: '甘肃',
    cn0971: '青海',
    cn0371: '河南',
    cn025: '江苏',
    cn027: '湖北',
    cn0731: '湖南',
    cn0791: '江西',
    cn0571: '浙江',
    cn020: '广东',
    cn0871: '云南',
    cn0591: '福建',
    cn0886: '台湾',
    cn0898: '海南',
    cn0351: '山西',
    cn028: '四川',
    cn029: '陕西',
    cn0851: '贵州',
    cn0551: '安徽',
    cn023: '重庆',
    cn010: '北京',
    cn021: '上海',
    cn022: '天津',
    cn0471: '内蒙古',
    cn0991: '新疆',
    cn0951: '宁夏',
    cn0771: '广西',
    cn0891: '西藏',
    cn0853: '澳门',
    cn0852: '香港',
};

const getDataTime = () => {
    const myDate = new Date();
    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1;
    const day = myDate.getDate();
    const hours = myDate.getHours();
    const minutes = myDate.getMinutes();
    const seconds = myDate.getSeconds();

    return {
        formatTime: `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`,
        formatYear: `${year}/${month}/${day}`,
    };
};

export const unfoldTypeHanlde = (articleShareUnfold = '1', regionFold = {}) => {
    const endTime = regionFold.endTime || '23:59:59';
    const startTime = regionFold.startTime || '00:00:00';
    const liveDataTime = getDataTime().formatYear;
    const startTimeStamp = new Date(`${liveDataTime} ${startTime}`).getTime();
    const endTimeStamp = new Date(`${liveDataTime} ${endTime}`).getTime();
    const liveTimeStamp = new Date().getTime();
    const regionBlacklist = (regionFold.regionBlacklist && regionFold.regionBlacklist.map(item => item.province)) || [];
    const prov = cookie.get('if_prov') || cookie.get('prov') || '';

    const liveProvName = allRegionList[prov] || '';
    let unfoldType = articleShareUnfold;

    if (
        regionFold.switch &&
        regionFold.switch !== '1' &&
        liveTimeStamp >= startTimeStamp &&
        liveTimeStamp <= endTimeStamp &&
        !regionBlacklist.includes(liveProvName)
    ) {
        unfoldType = regionFold.switch;
    }

    return unfoldType;
};
